import React from "react";
import { useParams, Navigate } from "react-router-dom";
import TicketDesigner from "./TicketDesigner";
import GroupTicketDesigner from "./GroupTicketDesigner";
import { dashboardPath } from "../utils/dashboardRoutes";

export default function TicketCustomizerRoute() {
  const { type, id } = useParams();

  if (!type || !id) {
    return <Navigate to={dashboardPath()} replace />;
  }

  if (type === "ticket-class") {
    return <TicketDesigner />;
  } else if (type === "pre-registration") {
    return <GroupTicketDesigner />;
  }

  return <Navigate to={dashboardPath()} replace />;
}
